import 'bootstrap3/dist/css/bootstrap.min.css';
import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import store from './store';
import router from './router';
import * as uiv from 'uiv';
// import "vue2-animate/dist/vue2-animate.min.css";
import 'vue-loading-overlay/dist/vue-loading.css';
import './assets/index.css';
import VueLocalStorage from 'vue-localstorage';
import '@openfonts/roboto_cyrillic';
import moment from 'moment';
import '@/assets/tailwind.css';
import i18n from './i18n';
import Highcharts from 'highcharts';
import Stock from 'highcharts/modules/stock';
import HighchartsVue from 'highcharts-vue';
import VueMask from 'v-mask';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import configApi from '@/config';

Vue.config.productionTip = false;
moment.defaultFormat = 'HH:mm:ss DD.MM.YYYY';

Vue.use(uiv);
Highcharts.setOptions({
  time: {
    useUTC: false,
  },
});
Stock(Highcharts);
Vue.use(HighchartsVue);
Vue.use(VueMask);
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    dsn: configApi.SENTRY_DNS,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['app.truffle.bid', 'preprod_app.tfuffle.bid'],
      }),
    ],
    tracesSampleRate: 1.0,
  });
}

declare module 'vue/types/vue' {
  interface Vue {
    $notify: any;
    $loading: any;
    $alert: any;
    $confirm: any;
    $Progress: any;
    localStorage: VueLocalStorage;
  }
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
